
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { processLink } from '../../utils/shortPinItem';



export const deleteStackNotes = createAsyncThunk(
    "stack-notes/deleteStackNotes",
    async ({ id, token }, { rejectWithValue }) => {
        try {

            const response = await axios.delete(
                `${process.env.REACT_APP_BASE_URL}/stack-notes/${id}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.status) {
                return ({ id: id, response: response.data.response })


            } else {
                return rejectWithValue("Failed to delete Stack note");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Network error");
        }
    }
);


export const updateStackNote = createAsyncThunk(
    "stack-notes/updateStackNote",
    async ({ id, formData, token }, { rejectWithValue }) => {
        try {

            console.log(formData)
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/stack-notes/${id}`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.status) {
                toast.success(response.data.response)

                return response.data;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (error) {
            toast.error(error.response?.data.message || 'Network error')

            return rejectWithValue(error.response?.data.message || "Error updating Note");
        }
    }
);

export const createStackNote = createAsyncThunk(
    "stack-notes/createStackNote",
    async ({ formData, token }, { rejectWithValue }) => {
        try {

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/stack-notes`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },

                }
            );

            if (response.data.status) {
                toast.success(response.data.response)
                return response.data;
            } else {
                return rejectWithValue("Failed to create note");
            }
        } catch (error) {

            toast.error(error.response?.data.message || 'Network error')
            return rejectWithValue(error.message || "Network error");
        }
    }
);

export const fetchStackNotes = createAsyncThunk(
    "stack-notes/fetchStackNotes",
    async ({ token }, { rejectWithValue }) => {
        console.log(token)
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/stack-notes`,

                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        offset: 1,
                        limit: 10
                    }
                }
            );

            if (response.data.status) {
                return response.data;
            } else {
                return rejectWithValue("Failed to fetch PDF");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Network error");
        }
    }
);

const stackNotesSlice = createSlice({
    name: 'stackNotes',
    initialState: {
        notes: [],
        isLoading: false,
        error: null,
    },
    reducers: {
        togglePinStackNote: (state, action) => {

            const pin = state.notes.find((link) => link.stackNoteId === action.payload.key);
            if (pin) {
                pin.pin = !pin.pin;

            }

            state.notes = processLink(state.notes);

        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStackNotes.pending, (state) => {
                state.isLoading = true;
                state.error = null
            })
            .addCase(fetchStackNotes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.notes = processLink(action.payload.response);
            })
            .addCase(fetchStackNotes.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            })
            .addCase(deleteStackNotes.pending, (state) => {
                state.isLoading = true
            })
            .addCase(deleteStackNotes.fulfilled, (state, action) => {
                state.isLoading = false;

                state.notes = state.notes.filter(
                    (note) => note.stackNoteId !== action.payload.id
                );
                toast.success(action.payload.response);
            })
            .addCase(deleteStackNotes.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(createStackNote.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createStackNote.fulfilled, (state, action) => {
                state.isLoading = false;


            })
            .addCase(createStackNote.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;

            })
            .addCase(updateStackNote.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateStackNote.fulfilled, (state, action) => {
                state.isLoading = false;

            })
            .addCase(updateStackNote.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;

            })
    },
});

export const { togglePinStackNote } = stackNotesSlice.actions;

export default stackNotesSlice.reducer;